import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@xsolla/ui-core';
import { Trash } from '@xsolla/ui-icons';

interface Props {
  onClick: () => void;
}

const DeleteButton = ({ onClick }: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <Button
      data-test-id="btn-delete-project"
      onClick={onClick}
      look="link"
      palette="danger"
      size="md">
      <Trash size={24} />
      {intl.messages['navigation.delete-project']}
    </Button>
  );
};

export default DeleteButton;
